import React from "react";

export default class Constants extends React.Component {
  static apisFolder = "/apis_test/";

  static ipAddress = "app.accademiadelcinema.it";
  // Usa HTTPS invece di HTTP per evitare problemi di Mixed Content in produzione
  static mainUrl = "https://" + Constants.ipAddress + Constants.apisFolder;
  static PdfTitleFontSize = 11;
  static PdfNormalFontSize = 10;
  static PdfFooterFontSize = 9;
}
